import {StorageKey} from "../../../../enums/StorageKey";
import {t} from "@lingui/macro";

export default {
    storageKey: StorageKey.report_quotation_by_customer,
    getReportLabel: () => t`Quotations By Customer`,
    getColumns: () => [],
};
